;(function () {
  angular
    .module('contrast.libraries')
    .controller('LibraryOutdatedBreakdownCtrl', LibraryOutdatedBreakdownCtrl)

  function LibraryOutdatedBreakdownCtrl(
    $log,
    $scope,
    $uibModal,
    $routeParams,
    $translate,
    LibraryFactory,
    ServerFactory,
    ApplicationFactory,
    LibrariesService,
    ErrorService,
    ChartConstants
  ) {
    'ngInject'

    var translGlobal = {
      plural_unitTimeMonth: $translate.instant(
        'plural_unitTimeMonths',
        { count: 1 },
        'messageformat'
      ),
      plural_unitTimeMonths: $translate.instant(
        'plural_unitTimeMonths',
        { count: 2 },
        'messageformat'
      ),
      plural_unitTimeYear: $translate.instant(
        'plural_unitTimeYears',
        { count: 1 },
        'messageformat'
      ),
      plural_unitTimeYears: $translate.instant(
        'plural_unitTimeYears',
        { count: 2 },
        'messageformat'
      ),
      plural_library: $translate.instant(
        'plural_libraries',
        { count: 1 },
        'messageformat'
      ),
      plural_libraries: $translate.instant(
        'plural_libraries',
        { count: 2 },
        'messageformat'
      ),
      title_libraryStatistics_statusUnknownLibraries: $translate.instant(
        'title_libraryStatistics_statusUnknownLibraries',
        {
          libraryPropName: $translate.instant(
            'title_libraryStatistics_libraryYearsBehind'
          )
        },
        'messageformat'
      ),
      title_libraryStatistics_statusUpToDateLibraries: $translate.instant(
        'title_libraryStatistics_statusUpToDateLibraries'
      ),
      title_libraryStatistics_statusMoreThan10YearsLibraries:
        $translate.instant(
          'title_libraryStatistics_statusMoreThan10YearsLibraries'
        )
    }

    var appId = $routeParams.appId
    var serverId = $routeParams.serverId

    $scope.showGraph = true
    $scope.chart = {}
    $scope.chart.data = []
    $scope.model = {}
    $scope.model.unit = translGlobal.plural_unitTimeYears

    $scope.chart.options = angular.copy(ChartConstants.barChartOptions)
    $scope.chart.options.tooltipOpts.content = function (label, xval, yval) {
      if (
        label == translGlobal.title_libraryStatistics_statusUpToDateLibraries ||
        label == translGlobal.title_libraryStatistics_statusUnknownLibraries
      ) {
        return (
          "<span class='size-h4'><strong>%s</strong><br/> " +
          yval +
          ' ' +
          (parseInt(yval) > 1 || parseInt(yval) === 0
            ? translGlobal.plural_libraries
            : translGlobal.plural_library) +
          '</span>'
        )
      }

      return (
        "<span class='size-h4'><strong>" +
        $translate.instant('variable_libraryStatistics_unitTimeBehind', {
          totalMonthsOrYears: '%s'
        }) +
        '</strong><br/> ' +
        yval +
        ' ' +
        (parseInt(yval) > 1 || parseInt(yval) === 0
          ? translGlobal.plural_libraries
          : translGlobal.plural_library) +
        '</span>'
      )
    }
    $scope.chart.options.legend = {
      show: true,
      labelFormatter: function (label, series) {
        var numApps = parseInt(series.data[0][1])
        return (
          '<strong>' +
          label +
          '</strong>: ' +
          series.data[0][1] +
          ' ' +
          (numApps > 1 || numApps === 0
            ? translGlobal.plural_libraries
            : translGlobal.plural_library)
        )
      }
    }

    $scope.chart.options.xaxis.show = true
    $scope.chart.options.xaxis.tickFormatter = function (val) {
      if (val == -2) {
        return '?'
      } else if (val == -1) {
        return '0'
      } else if (val == 0) {
        return '<1'
      } else {
        return val
      }
    }
    $scope.chart.options.xaxis.tickLength = 0
    $scope.chart.options.xaxis.tickSize = 1

    // Don't show a legend
    $scope.chart.options.legend.show = false

    $scope.chartParameters = {
      data: $scope.chart.data,
      options: $scope.chart.options,
      title: $translate.instant(
        'variable_libraryStatistics_averageTimeUnitOutOfDate',
        { yearsOrMonths: $scope.model.unit }
      )
    }

    function init() {
      if (appId) {
        $scope.libOutdatedBreakdownPromise =
          ApplicationFactory.getLibrariesOutOfDate(appId)
        $log.debug('loading app outdated')
      } else if (serverId) {
        $scope.libOutdatedBreakdownPromise =
          ServerFactory.getLibrariesOutOfDate(serverId)
        $log.debug('loading server outdated')
      } else {
        $scope.libOutdatedBreakdownPromise =
          LibraryFactory.getLibrariesOutOfDate()
        $log.debug('loading org outdated')
      }

      $scope.libOutdatedBreakdownPromise.then(function (response) {
        var breakdown = response.data.breakdown

        if (breakdown.length > 0) {
          var data = LibrariesService.buildLibraryOutdatedBreakdown(breakdown)
          $scope.showGraph = true
          var unitLabel
          if (data.isMonths) {
            $scope.model.averageMonths =
              response.data.average == -1 ? '?' : response.data.average
            unitLabel = translGlobal.plural_unitTimeMonth
            $scope.model.unit = translGlobal.plural_unitTimeMonths
          } else {
            $scope.model.averageMonths =
              response.data.average == -1
                ? '?'
                : Math.round(response.data.average / 12)
            unitLabel = translGlobal.plural_unitTimeYear
            $scope.model.unit = translGlobal.plural_unitTimeYears
          }

          angular.forEach(data.data, function (item) {
            if (item.label == 'Unknown') {
              if (item.value > 0) {
                $scope.chart.data.push({
                  label:
                    translGlobal.title_libraryStatistics_statusUnknownLibraries,
                  data: [[-2, item.value]],
                  color: '#767676'
                })
              }
            } else if (item.label == 'Up-to-date') {
              $scope.chart.data.push({
                label:
                  translGlobal.title_libraryStatistics_statusUpToDateLibraries,
                data: [[-1, item.value]],
                color: '#0000A0'
              })
            } else {
              if (item.label == 0) {
                $scope.chart.data.push({
                  label: '< 1 ' + unitLabel,
                  data: [[item.label, item.value]]
                })
              } else if (item.label == 10 && !data.isMonths) {
                $scope.chart.data.push({
                  label:
                    translGlobal.title_libraryStatistics_statusMoreThan10YearsLibraries,
                  data: [[item.label, item.value]]
                })
              } else if (item.label != 1) {
                $scope.chart.data.push({
                  label: item.label + ' ' + $scope.model.unit,
                  data: [[item.label, item.value]]
                })
              } else {
                $scope.chart.data.push({
                  label: item.label + ' ' + unitLabel,
                  data: [[item.label, item.value]]
                })
              }
            }
          })

          $scope.chartParameters.data = $scope.chart.data
          $scope.showModal = ChartConstants.showModal($scope, $uibModal)
        } else {
          $scope.showGraph = false
        }
      }, ErrorService.processError)
    }

    init()
  }
})()
